import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '@/store/authStore';
import * as authService from '@/services/authService';

export default function useAuth() {
  const { token, user, player, isAuthenticated, login, logout, updatePlayer } = useAuthStore();
  const navigate = useNavigate();

  const handleLogin = useCallback(async (username, password) => {
    const res = await authService.login({ username, password });
    const { token, user, player } = res.data.data;
    login(token, user, player);
    if (user.role === 'admin' || user.role === 'super_admin') navigate('/admin');
    else if (user.role === 'partner') navigate('/logista/dashboard');
    else navigate('/game');
    return res.data;
  }, [login, navigate]);

  const handleRegister = useCallback(async (data) => {
    const res = await authService.register(data);
    const { token, user, player } = res.data.data;
    login(token, user, player);
    navigate('/game');
    return res.data;
  }, [login, navigate]);

  const handleLogout = useCallback(() => {
    logout();
    navigate('/');
  }, [logout, navigate]);

  return { token, user, player, isAuthenticated, handleLogin, handleRegister, handleLogout, updatePlayer };
}
